import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageService } from '../services/base/local-storage.service';

@Injectable()

export class AddTokenInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.localStorageService.get('api-token');

    if (token !== null && (
      request.url.indexOf('https://maps.googleapis.com') === -1 &&
      request.url.indexOf('https://api.pdok.nl') === -1
    )) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
    );
  }
}
